module.exports = __webpack_public_path__ + "img/hat_female_beanie_mask.05f64309.png";